var map = {
	"./service1.jpg": 553,
	"./service2.jpg": 958,
	"./service3.jpg": 915,
	"./service4.jpg": 328,
	"./service5.jpg": 293,
	"./service6.jpg": 90,
	"./service7.jpg": 255,
	"./service8.jpg": 396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;